import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  useEffect(() => {
    document.title = 'Page Not Found | CEC Track';
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.setAttribute('content', 'noindex, nofollow');
  }, []);

  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'IBM Plex Sans, system-ui, sans-serif',
      padding: '2rem',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{
          fontSize: '6rem',
          fontWeight: 800,
          color: '#0F1F3D',
          lineHeight: 1,
          letterSpacing: '-0.04em',
          marginBottom: '0.5rem',
        }}>
          404
        </div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#1f2937', marginBottom: '0.75rem' }}>
          Page Not Found
        </h1>
        <p style={{ color: '#6b7280', fontSize: '1rem', lineHeight: 1.6, marginBottom: '2rem' }}>
          The page you're looking for doesn't exist or has been moved.
          If you were looking for CE requirements, try one of our state pages below.
        </p>

        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
          <Link to="/" style={{
            background: '#0F1F3D', color: '#fff',
            padding: '0.6rem 1.5rem', borderRadius: 8,
            textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem',
          }}>
            Go Home
          </Link>
          <Link to="/how-it-works" style={{
            background: '#f1f5f9', color: '#0F1F3D',
            padding: '0.6rem 1.5rem', borderRadius: 8,
            textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem',
          }}>
            How It Works
          </Link>
          <Link to="/contact" style={{
            background: '#f1f5f9', color: '#0F1F3D',
            padding: '0.6rem 1.5rem', borderRadius: 8,
            textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem',
          }}>
            Contact Us
          </Link>
        </div>

        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '1.5rem' }}>
          <p style={{ color: '#9ca3af', fontSize: '0.85rem', marginBottom: '0.75rem' }}>
            Popular state CE requirement guides:
          </p>
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { label: 'New York', href: '/ny-license-renewal' },
              { label: 'Texas', href: '/tx-license-renewal' },
              { label: 'California', href: '/ca-license-renewal' },
              { label: 'Florida', href: '/fl-license-renewal' },
              { label: 'New Jersey', href: '/nj-license-renewal' },
            ].map(s => (
              <Link key={s.href} to={s.href} style={{
                color: '#2563eb', fontSize: '0.85rem', textDecoration: 'none',
                padding: '0.3rem 0.75rem', borderRadius: 6,
                background: '#eff6ff', fontWeight: 500,
              }}>
                {s.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
